import { useRouteMatch } from 'react-router';

import { types } from './shared';
import { usePrompts } from './usePrompts';
import { PromptsList } from './PromptsList';
import { PromptModal } from './PromptModal';
import { useActions } from '../../molecules';
import { CampaignName } from '../../templates';
import { useAppContext } from '../../molecules';
import { Button, Dropdown } from '../../components';
import { Form, FormItem, TopPanel } from '../../components';
import { addPrompt, updatePrompt, deletePrompt } from '../../api';
import type { Item, CreateItem, UpdateItem } from './usePrompts';

type ComponentProps = { campaignId: string };

const PromptsForCampaignComponent: React.FC<ComponentProps> = ({
  campaignId,
}) => {
  const { meta } = useAppContext();
  const campaign = meta.campaigns.find(item => item.value === campaignId);

  const listResult = usePrompts(campaignId);
  const { nodes, refresh, filters, setFilters, initializing } = listResult;

  const {
    isOpened,
    updating,
    initialValues,
    handleClose,
    handleAdd,
    handleEdit,
    handleStartAdd,
    handleStartEdit,
    handleStartDelete,
  } = useActions<Item, CreateItem, UpdateItem>({
    name: 'Prompt',
    onRefresh: refresh,

    onAdd: addPrompt,
    onEdit: updatePrompt,
    onDelete: deletePrompt,
  });

  return (
    <div className="flex flex-col gap-y-md w-full">
      {!!isOpened && (
        <PromptModal
          loading={updating}
          onClose={handleClose}
          campaignId={campaignId}
          initialValues={initialValues}
          onSumbit={initialValues ? handleEdit : handleAdd}
        />
      )}
      <Form<NonNullable<typeof filters>>
        initialValue={filters}
        onChange={setFilters}
      >
        <TopPanel
          topLeftContent={
            !!campaign && (
              <CampaignName
                inline
                id={campaign.value}
                name={String(campaign.label)}
                className="mr-auto font-medium text-big truncate"
              />
            )
          }
          buttonsRightContent={
            <>
              <FormItem<NonNullable<typeof filters>> name="promptType" label="">
                <Dropdown placeholder="Type" grow={false} options={types} />
              </FormItem>

              <Button
                icon="plus"
                action="manage_outreach_campaigns"
                onClick={() => handleStartAdd()}
              >
                Add Prompt
              </Button>
            </>
          }
        />
      </Form>
      <PromptsList
        data={nodes || []}
        updating={updating}
        initializing={initializing}
        onStartEdit={handleStartEdit}
        onStartDelete={handleStartDelete}
        emptyMessage="There are no prompts for this Campaign."
      />
    </div>
  );
};

const PromptsForCampaign = () => {
  const {
    params: { id },
  } = useRouteMatch<{ id: string }>();

  return id ? <PromptsForCampaignComponent campaignId={id} /> : null;
};

export default PromptsForCampaign;
